const ClockIcon = () => <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 20.5H5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M10 24.25H5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M15 26.75C21.2132 26.75 26.25 21.7132 26.25 15.5C26.25 9.2868 21.2132 4.25 15 4.25C8.7868 4.25 3.75 9.2868 3.75 15.5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M14.5117 9.25V15.9887H20.0005" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

const ChevronIcon = () => <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5 16L10.5 12L14.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>



export {
  ClockIcon,
  ChevronIcon
}

